export default "__VITE_ASSET__Cb$HHOFZ__"